export default __webpack_public_path__ + "static/media/serviceBg2.c58d21f5.jpg";